import { queryOptions } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/constants/time';
import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type UserV2 = NonNullable<
  | paths['/v2/users/me']['get']['responses'][200]['content']['application/json']['data']
  | paths['/v2/users/{id}']['get']['responses'][200]['content']['application/json']['data']
>;

export async function getUserV2(id: number | 'me'): Promise<UserV2> {
  if (id === 'me') {
    const { data } = await fetchClient.GET('/v2/users/me');

    if (!data?.data) {
      throw new Error('Current user not found');
    }

    return data.data as UserV2;
  }

  const { data } = await fetchClient.GET('/v2/users/{id}', {
    params: { path: { id } },
  });

  if (!data?.data) {
    throw new Error('User not found');
  }

  return data.data as UserV2;
}

export const getUserV2QueryOptions = (id?: number | string) =>
  queryOptions<UserV2>({
    queryKey: ['usersV2', id],
    queryFn: () => getUserV2(id === 'me' ? 'me' : Number(id)),
    staleTime: ONE_MINUTE,
    enabled: !!id,
  });

export type UserPublicV2 = NonNullable<
  paths['/v2/users/public/{id}']['get']['responses'][200]['content']['application/json']['data']
>;
